<template>
  <div id="main-content" class="add-place">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <form>
        <el-row>
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="required-star">* </span><span class="form-lable">{{ $t('common.bus_stop') }}</span>
            </el-col>
            <input class="input" v-model="place_data.name" type=""/>
            <el-col v-if="error_message.name" :offset="8" :span="16">
              <span v-for="(value, key) in error_message.name" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-col>
          <el-col  :span="12" style="display: inline">
            <el-col :span="8">
              <span class="required-star">* </span><span class="form-lable">{{ $t('common.address') }}</span>
            </el-col>
            <input class="input" v-model="place_data.address" type=""/>
            <el-col v-if="error_message.address" :offset="8" :span="16">
              <span v-for="(value, key) in error_message.address" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="12" style="display: inline">
            <el-col :span="8"><span style="width: 100%" class="form-lable">{{ $t('common.school') }}</span></el-col>
            <input type="checkbox" @change="didSelectSchool" v-model="place_data.is_school" name="" value="">
          </el-col>
          <el-col  :span="12" style="display: inline">
            <el-col :span="8"><span style="width: 100%" class="form-lable">{{ $t('common.parking_lot') }}</span></el-col>
            <input type="checkbox" @change="didSelectParking" v-model="place_data.is_parking" name="" value="">
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="required-star">* </span><span class="form-lable">{{ $t('bus_stop.pickup_time') }}</span>
            </el-col>
            <el-time-picker
              class="float-left"
              v-model="place_data.pickup_time"
              format="HH:mm"
              value-format="HH:mm"
              placeholder="">
            </el-time-picker>
            <el-col v-if="error_message.pickup_time" :offset="8" :span="16">
              <span v-for="(value, key) in error_message.pickup_time" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-col>
        </el-row>

        <el-row style="padding-top: 50px">
          <el-button style="font-size: 20px; width: 30%" type="success" @click="submitAction">{{ $t('common.submit') }}</el-button>
        </el-row>
      </form>
    </el-col>
  </div>
</template>

<script>
  import PageTitle from '@/components/PageTitle'

  export default {
    name: "AddPlace",
    components: {
      PageTitle
    },
    data: function () {
      return {
        backLink: `/place?action=back`,
        title: 'bus_stop.add_bus_stop',
        place_data: {
          name: "",
          address: "",
          is_school: false,
          pickup_time: "",
          is_parking: false
        },
        error_message: {
          name: [],
          address: [],
          pickup_time: []
        },
      }
    },
    methods: {
      submitAction: function () {
        let check = this.validate()
        if (check) {
          let successCallback = () => {
            this.$router.push('/place')
          };
          let payload = {
            successCallback,
            data: this.place_data
          }

          this.$store.dispatch('place/createPlace', payload);
        } else {
          this.$store.commit('openNotification', {
            type: 'error',
            message: this.$t('common.please_check_input_error')
          })
          return false
        }
      },
      validate: function () {
        var check = true
        this.error_message.name = []
        if (this.place_data.name === "") {
          this.error_message.name.push('* ' + this.$t('common.bus_stop_is_required'))
          check = false
        }

        this.error_message.address = []
        if (this.place_data.address === '') {
          check = false
          this.error_message.address.push('* ' + this.$t('common.address_is_required'))
        }

        this.error_message.pickup_time = []
        if (this.place_data.pickup_time === '') {
          check = false
          this.error_message.pickup_time.push('* ' + this.$t('bus_stop.pickup_time_is_required'))
        }

        return check
      },
      didSelectSchool: function (e) {
        if (e.target.checked) {
          this.place_data.is_parking = false
        }
      },
      didSelectParking: function (e) {
        if (e.target.checked) {
          this.place_data.is_school = false
        }
      }
    },
    computed: {
      isDisableTime: function () {
        return this.place_data.is_school
      }
    }
  }
</script>

<style lang="scss">

</style>
